/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, {
  useRef,
  useCallback,
  useMemo,
  useState,
  useEffect,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Select from '../../../../components/Select';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import { Container } from './styles';

import { ArrayFilters } from '../../../../interfaces/core';

interface FiltersModalProps {
  show: boolean;
  title: string;
  filters: ArrayFilters;
  departamentos: any;
  handleClose(): void;
  handleApplyFilter(filters: any): void;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  handleClose,
  handleApplyFilter,
  filters,
  departamentos,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const [defaultDepartment, setDefaultDepartment] = useState<any>(null);

  const filtersObject = useMemo(() => {
    const newObj = filters.filters.reduce(
      (key, name) => Object.assign(key, name),
      {},
    );
    return newObj;
  }, [filters]);

  const departamentosOptions = useMemo(() => {
    const options = departamentos.map((dep: any) => {
      return { value: dep.CodigoDepartamento, label: dep.Nome };
    });
    return options;
  }, [departamentos]);

  const statusOptions = [
    { value: 'I', label: 'Inativo' },
    { value: 'A', label: 'Ativo' },
  ];

  const handleSubmit = useCallback(
    (data: any) => {
      handleApplyFilter(data);
      if (data.departamento) {
        const filteredDepartment = departamentos.filter(
          (dep: any) => dep.CodigoDepartamento === data.departamento,
        );
        const formattedDepartment = {
          name: filteredDepartment[0].CodigoDepartamento,
          label: filteredDepartment[0].Nome,
        };
        localStorage.setItem(
          '@TransfacilPJ:DepartmentFilter',
          JSON.stringify(formattedDepartment),
        );
      }
    },
    [departamentos],
  );

  useEffect(() => {
    const localStoragedDepartmentoFIlter = localStorage.getItem(
      '@TransfacilPJ:DepartmentFilter',
    );
    if (localStoragedDepartmentoFIlter) {
      const department = JSON.parse(localStoragedDepartmentoFIlter);
      setDefaultDepartment(department);
    }
  }, []);
  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Form ref={formTableRef} onSubmit={handleSubmit}>
          {defaultDepartment !== null && (
            <Select
              name="departamento"
              label="Departamento"
              placeholder="Selecione o departamento"
              defaultValue={defaultDepartment}
              options={departamentosOptions}
            />
          )}
          {defaultDepartment === null && (
            <Select
              name="departamento"
              label="Departamento"
              placeholder="Selecione o departamento"
              options={departamentosOptions}
            />
          )}
          <Select
            name="status"
            label="Status"
            placeholder="Selecione o status"
            defaultValue={
              filtersObject?.status === 'I'
                ? {
                    value: filtersObject?.status,
                    label: 'Inativo',
                  }
                : filtersObject?.status === 'A'
                ? {
                    value: filtersObject?.status,
                    label: 'Ativo',
                  }
                : null
            }
            options={statusOptions}
          />
          <div className="buttonsContainer">
            <Button color="orange" padding="1" type="submit">
              Aplicar Filtros
            </Button>
          </div>
        </Form>
      </Modal>
    </Container>
  );
};

export default FiltersModal;
